@import "../../globals/scss/label";

.component {
  .inline {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-content: stretch;
    gap: $baseline-4;

    &.input-container {
      gap: $baseline-2;
    }
  }
}
